import React, { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { ReactComponent as NewDesignIcon } from "../../../../assets/svg/NewDesignIcon.svg";
import { ReactComponent as ArrowIcon } from "../../../../assets/svg/ArrowIcon.svg";
import styles from "./styles";
import { isEmpty } from "lodash";
import {
  getImageSrc,
  formattedAmountWithoutAed,
} from "../../../../utils/CommonFunction";
import { getApiData } from "../../../../utils/APIHelper";
import { ReactComponent as SmallDhiramIcon } from "../../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../utils/CurrencyUtils";

const GroupInclusionList = ({ packageDetails }) => {
  const [packageGroups, setPackageGroups] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (packageDetails && packageDetails?.id) {
      getGroupDetailsApiCall(packageDetails?.id);
    }
  }, [packageDetails?.id]);

  async function getGroupDetailsApiCall(id) {
    setLoader(true);
    try {
      const response = await getApiData(
        `api/v2/package/${id}/groups`,
        "GET",
        {},
        { "Content-Type": "application/json" },
        true
      );
      if (response) {
        setPackageGroups(response);
        setExpandedInclusions(response.map((group) => group.id));
      }
      setLoader(false);
    } catch (error) {
      console.log("error:===>>>", error);
      setLoader(false);
    }
  }

  const [expandedInclusions, setExpandedInclusions] = useState([]);

  const toggleMilestone = (milestoneId) => {
    setExpandedInclusions((prevExpanded) =>
      prevExpanded.includes(milestoneId)
        ? prevExpanded.filter((id) => id !== milestoneId)
        : [...prevExpanded, milestoneId]
    );
  };
  return (
    <>
      {!isEmpty(packageGroups) && (
        <>
          <h3 style={styles.sub_heading}>Package Groups</h3>
          <div style={{ ...styles.columnFlex }}>
            {packageGroups?.map((item) => (
              <div key={item.id}>
                <div
                  style={{
                    ...styles.rowFlex,
                    justifyContent: "space-between",
                    borderRadius: "12px",
                    background: "#F7F7F7",
                    padding: "1vh 1vw",
                    alignItems: "center",
                  }}
                >
                  <div style={{ ...styles.rowFlex, flex: 1 }}>
                    <Box display="flex" alignItems="center">
                      <span style={styles.small_sub_heading}>{item?.name}</span>
                    </Box>
                  </div>

                  <div style={{ ...styles.columnFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>Group By</h3>
                    <div style={styles.small_sub_heading}>{item?.groupBy}</div>
                  </div>

                  <IconButton onClick={() => toggleMilestone(item.id)}>
                    {expandedInclusions.includes(item.id) ? (
                      <KeyboardArrowUp />
                    ) : (
                      <KeyboardArrowDown />
                    )}
                  </IconButton>
                </div>

                {expandedInclusions?.includes(item.id) && (
                  <div
                    style={{
                      ...styles.columnFlex,
                      ...styles.budgetContainer,
                      gap: "15px",
                      marginBottom: "2vh",
                    }}
                  >
                    {item?.inclusions?.map((budgetItem) => (
                      <div
                        key={budgetItem.id}
                        style={{
                          ...styles.rowFlex,
                          gap: "0px",
                          alignItems: "flex-start",
                        }}
                      >
                        <ArrowIcon />
                        {console.log("budgetItem", budgetItem, item)}
                        <div style={styles.budgetRow}>
                          <div style={{ ...styles.rowFlex, flex: 1 }}>
                            <Box display="flex" alignItems="center">
                              <Box
                                component="img"
                                src={getImageSrc(budgetItem?.image?.path)}
                                alt="Inclusion Icon"
                                sx={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: "8px",
                                  border: "2px solid white",
                                  boxShadow: "0px 4px 2.67px 0px #00000026",
                                  marginRight: 1,
                                }}
                              />
                              <span style={styles.small_sub_heading}>
                                {budgetItem?.name}
                              </span>
                            </Box>
                          </div>

                          <div style={{ ...styles.rowFlex, flex: 1 }}>
                            <div style={styles.small_text}>
                              <div
                                style={{
                                  ...styles.rowFlex,
                                  ...styles.small_sub_heading,
                                }}
                              >
                                <NewDesignIcon />
                                {budgetItem?.materialType}
                              </div>
                            </div>
                          </div>

                          <div style={{ ...styles.columnFlex, flex: 1 }}>
                            <h3 style={styles.small_text}>Units</h3>
                            <div style={styles.small_sub_heading}>
                              {budgetItem?.materialUnit}
                            </div>
                          </div>

                          <div style={{ ...styles.columnFlex, flex: 1 }}>
                            <h3 style={styles.small_text}>Cost</h3>
                            <div
                              style={{
                                ...styles.small_sub_heading,
                                ...styles.rowFlex,
                                gap: "5px",
                              }}
                            >
                              {budgetItem?.cost && renderCurrencyIcon('small')}
                              {budgetItem?.cost
                                ? formattedAmountWithoutAed(budgetItem?.cost)
                                : "-"}
                            </div>
                          </div>

                          <div style={{ ...styles.columnFlex, flex: 1 }}>
                            <h3 style={styles.small_text}>Description</h3>
                            <div style={styles.small_sub_heading}>
                              {budgetItem?.description}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default GroupInclusionList;
